module.exports = __webpack_public_path__ + "static/media/icon-cd.e4471d85.svg";